var _defs, _path, _rect, _line, _line2, _line3, _line4, _line5, _line6, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMonochrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 100",
    role: "img",
    "aria-label": "SoKo Water Systems monochrome",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SoKo Water Systems (monochrome)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mono-tank-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 16 L 66 16 Q 74 16 74 24 L 74 80 Q 74 88 66 88 L 10 88 Q 2 88 2 80 L 2 24 Q 2 16 10 16 Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "mono-hatch",
    patternUnits: "userSpaceOnUse",
    width: 4,
    height: 4,
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 4,
    stroke: "#0B3A4A",
    strokeWidth: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 10 16 L 66 16 Q 74 16 74 24 L 74 80 Q 74 88 66 88 L 10 88 Q 2 88 2 80 L 2 24 Q 2 16 10 16 Z",
    fill: "none",
    stroke: "#0B3A4A",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 52,
    width: 72,
    height: 36,
    fill: "url(#mono-hatch)",
    clipPath: "url(#mono-tank-clip)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 52,
    x2: 74,
    y2: 52,
    stroke: "#0B3A4A",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 26,
    x2: 84,
    y2: 26,
    stroke: "#0B3A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 39,
    x2: 84,
    y2: 39,
    stroke: "#0B3A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 52,
    x2: 88,
    y2: 52,
    stroke: "#0B3A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 65,
    x2: 84,
    y2: 65,
    stroke: "#0B3A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 78,
    x2: 84,
    y2: 78,
    stroke: "#0B3A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 72,
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: 52,
    fontWeight: 500,
    fill: "#0B3A4A",
    letterSpacing: 3
  }, "SOKO")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 92,
    fontFamily: "'Fraunces', Georgia, serif",
    fontSize: 10,
    fontWeight: 400,
    fill: "#0B3A4A",
    letterSpacing: 3
  }, "WATER SYSTEMS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMonochrome);
export default __webpack_public_path__ + "static/media/logo_monochrome.71f197b57d26258e4c3e3e4ef4a2a905.svg";
export { ForwardRef as ReactComponent };